import UpgradeAccountError from './UpgradeAccountError';
class InvestorHasInvalidState extends UpgradeAccountError {
    constructor(options) {
        super('The investor has an invalid state', options);
    }
}
export default InvestorHasInvalidState;
